/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState, useEffect } from "react";

export type SelectedDictionary = { id?: number; name?: string } | null;

export type SelectedDictionaryContextType = {
  selected: SelectedDictionary;
  setSelected: (d: SelectedDictionary) => void;
};

const SelectedDictionaryContext = createContext<SelectedDictionaryContextType | undefined>(undefined);

export function useSelectedDictionary() {
  const ctx = useContext(SelectedDictionaryContext);
  if (!ctx) {
    throw new Error("useSelectedDictionary must be used within SelectedDictionaryProvider");
  }
  return ctx;
}

const STORAGE_KEY = "selected_dictionary";

export const SelectedDictionaryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Initialize from localStorage
  const [selected, setSelected] = useState<SelectedDictionary>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  // Save to localStorage whenever it changes
  useEffect(() => {
    try {
      if (selected) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(selected));
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch {
      // ignore storage errors
    }
  }, [selected]);

  return (
    <SelectedDictionaryContext.Provider value={{ selected, setSelected }}>
      {children}
    </SelectedDictionaryContext.Provider>
  );
};